import { format, parseISO } from 'date-fns';
import { getStatusConfig as _getStatusConfig } from './appointmentStatus';

// Format date to display in a readable format
export function formatDate(dateString: string | null | undefined): string {
  if (!dateString) return '';
  try {
    return format(parseISO(dateString), 'PPP');
  } catch (error) {
    console.error('Error formatting date:', error);
    return '';
  }
}

// Format date with time
export function formatDateTime(dateString: string | null | undefined, timeString?: string | null): string {
  if (!dateString) return '';
  try {
    // If time is provided, combine date and time, otherwise just use date
    const dateTimeString = timeString 
      ? `${dateString}T${timeString}` 
      : dateString;
    
    return format(parseISO(dateTimeString), 'PPp');
  } catch (error) {
    console.error('Error formatting date time:', error);
    return '';
  }
}

// Generate random string for public links
export function generatePublicLink(): string {
  return Math.random().toString(36).substring(2, 15) + 
         Math.random().toString(36).substring(2, 15);
}

// Calculate success rate for prospecting
export function calculateSuccessRate(positiveResponses: number, contactsReached: number): string {
  if (contactsReached === 0) return '0%';
  const rate = (positiveResponses / contactsReached) * 100;
  return `${rate.toFixed(1)}%`;
}

// Get status badge color based on appointment status
export function getStatusColor(status: string): string {
  const config = _getStatusConfig(status);
  return `${config.bg} ${config.color}`;
}